import { apiClient, ApiError } from '@/lib/api/client';
import { createComponentLogger } from '@/lib/utils/logger';

const logger = createComponentLogger('SpecialtiesApi');
const AUTH_API_BASE_URL = import.meta.env.VITE_AUTH_API_URL;

/**
 * A selectable practitioner specialty.
 *
 * The catalogue lives in Medplum as a CodeSystem shared across product lines,
 * so this is the only place the frontend learns which specialties exist or what
 * they are called — adding one is a data change in Medplum, not a release here.
 *
 * `code` doubles as the case-sheet department key; there is no second
 * identifier to keep in step.
 */
export interface Specialty {
  code: string;
  display: string;
}

/** Code system of catalogue specialties on PractitionerRole.specialty. */
export const SPECIALTY_CODE_SYSTEM = 'https://pranik.ai/fhir/CodeSystem/practitioner-specialty';

export async function fetchSpecialties(): Promise<Specialty[]> {
  try {
    const { data } = await apiClient.get<{ specialties: Specialty[] }>('/v2/specialties', {
      baseUrl: AUTH_API_BASE_URL,
    });
    return data.specialties ?? [];
  } catch (error) {
    const message = error instanceof ApiError ? error.message : 'Failed to load specialties';
    logger.error('Failed to fetch specialties:', error);
    throw new Error(message);
  }
}
